import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { APPCONFIG } from "../config";

@Injectable()
export class EmailService extends BaseService {
    constructor() {
        super();
        this._api = '/api/emails/';        
    }

    getEmailsDevedor(devedorid: number) {        
        return this.get(`${this._api}?devedorid=${devedorid}&start=0&limit=20`);       
    }

    postBoletoEmail(dados: any) {
        return this.post('/api/boletos/enviarSegundaVia', dados);
    }  

    postBoletoEmailPortal(dados: any) {
        return this.post('/api/boletos/enviarSegundaViaPortal', dados);
    }  
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/email.service.ts